module.exports = {"full_name":"Vollständiger Name","enter_full_name":"Gib deinen vollständigen Namen ein","first_name_hint":"Dein vollständiger rechtlicher Name, wie er in deinen amtlichen Dokumenten angegeben ist","last_name_hint":"Dein vollständiger rechtlicher Name, wie er in deinen amtlichen Dokumenten angegeben ist"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/fullName.json
// module id = 487
// module chunks = 248 1690